import React, { MutableRefObject } from 'react'
import { TextProps, Text } from 'theme-ui'
import { ForwardRef } from '@theme-ui/components/src/types'
import isArray from 'lodash/isArray'

interface TextWithBreakpointVariantProps extends Omit<TextProps, 'variant'> {
  variant: string[] | string
  textRef?: MutableRefObject<HTMLDivElement | null>
}

// ForwardRef is important here, otherwise the tooltip in TextWithOverFlowAndTippyPopup is not displayed
export const TextWithBreakpointVariant: ForwardRef<HTMLDivElement, TextWithBreakpointVariantProps> =
  React.forwardRef(function TextWithBreakpointVariant(props, ref) {
    const { variant, sx, ...rest } = props
    const mobileBreakpoint = 0
    const tabletBreakpoint = 1
    const desktopBreakpoint = 2
    const isVariantArray = isArray(variant)

    return (
      <Text
        {...rest}
        ref={ref}
        sx={{
          '@media screen and (max-width: 767px)': {
            variant: `text.${isVariantArray ? variant?.[mobileBreakpoint] : variant}`,
          },
          '@media screen and (min-width: 768px) and (max-width: 1119px)': {
            variant: `text.${isVariantArray ? variant?.[tabletBreakpoint] : variant}`,
          },
          '@media screen and (min-width: 1120px)': {
            variant: `text.${
              isVariantArray ? variant?.[desktopBreakpoint] || variant?.[tabletBreakpoint] : variant
            }`,
          },
          ...sx,
        }}
      />
    )
  })
